
import { Component, Vue } from "vue-property-decorator";
import CreatorApplicationList from "./CreatorApplicationList.vue";

@Component({ components: { CreatorApplicationList } })
export default class CreatorInvitationsPage extends Vue {}
